import { recipeApp, type OsRecipe } from '../os-recipes.js';

const PHOTOS = recipeApp('com.apple.Photos');

/** photos: its app recipes as data (Mac recipes R3). Every entry ships held until its drill lifts it.
 *  Acts on the selection run with Photos in front, on the photos the person sees. Its reads are
 *  verbs, not recipes. The research rows not here are on the R3 review lists. */
export const RECIPES: readonly OsRecipe[] = [
  {
    id: 'photos.make_album', app: PHOTOS, status: 'held',
    title: 'Make an album',
    description: 'Make an album ("make an album called goa trip").',
    params: { name: { kind: 'literal', description: "The new album's name", cut: 'called' } },
    steps: [{ op: 'verb', id: 'photos.create_album', params: { name: '{name}' } }],
    tier: 'reversible', verify: 'echo', cues: ['banao', 'new album', 'make an album', 'create an album', 'start an album', 'make a photos album', 'naam ka album banao'],
    reply: 'Made the album {name} in Photos.',
  },
  {
    id: 'photos.search_show', app: PHOTOS, status: 'held', opens: true,
    title: 'Show photos of a thing, place, person or date',
    description: 'Show photos of a thing, place, person or date ("show me photos of the beach").',
    params: { query: { kind: 'literal', description: 'What to search for, in their words', cut: 'query' } },
    steps: [{ op: 'open_url', template: 'photos:search?searchTerm={query}' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', verify: 'echo', cues: ['show', 'find', 'search', 'pull', 'photos', 'pictures', 'dikhao'],
    reply: 'Showing photos of {query}.',
  },
  {
    id: 'photos.show_favorites', app: PHOTOS, status: 'held', opens: true,
    title: 'Show Favorites',
    description: 'Show Favorites ("show my favorite photos").',
    params: {},
    steps: [{ op: 'open_url', template: 'photos://album?name=favorites' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', verify: 'echo', cues: ['favorites', 'favourites', 'hearted', 'favorite', 'pictures i hearted', 'favorites dikhao'],
    reply: 'Showing your Favorites in Photos.',
  },
  {
    id: 'photos.show_library', app: PHOTOS, status: 'held', opens: true,
    title: 'Show all photos (the library, newest first)',
    description: 'Show all photos (the library, newest first) ("show all my photos").',
    params: {},
    steps: [{ op: 'open_url', template: 'photos:all-photos' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', verify: 'echo', cues: ['all', 'library', 'recent', 'recents', 'latest', 'latest pictures i took'],
    reply: 'Showing all your photos.',
  },
  {
    id: 'photos.show_albums', app: PHOTOS, status: 'held', opens: true,
    title: 'Show the albums list',
    description: 'Show the albums list ("show my albums").',
    params: {},
    steps: [{ op: 'open_url', template: 'photos:albums' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', verify: 'echo', cues: ['albums', 'photo albums', 'albums dikhao', 'all my albums', 'albums view'],
    reply: 'Showing your albums in Photos.',
  },
  {
    id: 'photos.info', app: PHOTOS, status: 'held', opens: true,
    title: 'Show photo info',
    description: 'Show photo info ("show info for this photo").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+i' }],
    tier: 'reversible', cues: ['info', 'details', 'metadata', 'taken', 'info for this photo', 'photo details', 'info dikhao'],
    reply: 'Showing the info window.',
  },
  // No "open" or "close" cue: "open Photos" must never read as this. A space types in a field, so the guard runs first.
  {
    id: 'photos.viewer_toggle', app: PHOTOS, status: 'held',
    title: 'Toggle the selected photo open or closed',
    description: 'Open or close the selected photo ("open this photo").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'focus_not_editable' }, { op: 'key', chord: 'space' }],
    tier: 'reversible', cues: ['photo', 'picture', 'view', 'grid', 'video', 'this photo', 'view this', 'close the photo', 'back to the grid', 'play this video'],
    reply: 'Done.',
  },
  {
    id: 'photos.hide_sidebar', app: PHOTOS, status: 'held',
    title: 'Hide the Photos sidebar',
    description: 'Hide the Photos sidebar ("hide the sidebar").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Hide Sidebar'], pair: ['Hide Sidebar', 'Show Sidebar'] }],
    tier: 'reversible', cues: ['hide', 'chhupao', 'hide the sidebar', 'hide sidebar', 'sidebar chhupao'],
    reply: 'Hid the sidebar in Photos.',
  },
  {
    id: 'photos.zoom_in', app: PHOTOS, status: 'held',
    title: 'Zoom in on Photos',
    description: 'Zoom in on Photos ("zoom in").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Zoom In'] }],
    tier: 'reversible', cues: ['zoom', 'bigger', 'larger', 'zoom in on', 'thumbnails bigger', 'zoom karo', 'bigger pictures'],
    reply: 'Zoomed in.',
  },
  {
    id: 'photos.fullscreen', app: PHOTOS, status: 'held',
    title: 'Put Photos in full screen',
    description: 'Photos full screen ("make photos full screen").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'ctrl+cmd+f' }],
    tier: 'reversible', cues: ['full screen', 'fullscreen', 'exit full screen'],
    reply: 'Toggled full screen.',
  },
  {
    id: 'photos.import_panel', app: PHOTOS, status: 'held', opens: true,
    title: 'Open the import panel',
    description: 'Open the import panel ("import photos").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+i' }],
    tier: 'reversible', cues: ['import', 'import pictures', 'import some pictures', 'import window'],
    reply: 'Opened Import. Pick the files to bring in.',
  },
  {
    id: 'photos.import_from_iphone', app: PHOTOS, status: 'held', opens: true,
    title: "Show the connected iPhone's photos for import",
    description: 'Show the connected iPhone\'s photos for import ("import from my iphone").',
    params: {},
    steps: [{ op: 'open_url', template: 'photos://devices?index=0' }, { op: 'await_front', timeoutMs: 3000 }],
    tier: 'reversible', verify: 'echo', cues: ['iphone', 'phone', 'camera', 'device', 'import from my iphone', 'phone se photos import', 'import from the camera'],
    reply: 'Showing your device in Photos. Pick what to import.',
  },
  // Sharing is outward: the yes only opens the share sheet, and the person picks who gets it.
  {
    id: 'photos.share_selection', app: PHOTOS, status: 'held',
    title: 'Open the share menu for the selection',
    description: 'Open the share menu for the selection ("share this photo").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['File', 'Share…'] }],
    tier: 'irreversible', yesWord: 'share', cues: ['share', 'airdrop', 'send', 'share this photo', 'share these pictures', 'airdrop this', 'ye photo share', 'share these', 'share for this picture'],
    reply: 'Share the selected photos from Photos?',
  },
  // "Remove" is a destructive menu word to the lint: it waits for the yes. Drill the live title (Remove N Photos from Album?).
  {
    id: 'photos.remove_from_album', app: PHOTOS, status: 'held',
    title: 'Remove the selection from this album (keeps it in the library)',
    description: 'Remove the selection from this album (keeps it in the library) ("remove this from the album").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'menu', path: ['Image', 'Remove from Album'] }],
    tier: 'irreversible', cues: ['remove', 'hatao', 'out', 'remove this', 'remove these from this', 'take this out', 'remove from album', 'remove from the album', 'album se hatao', 'remove this from the album', 'remove these from this album'],
    reply: 'Remove the selected photos from this album? They stay in your library.',
  },
  {
    id: 'photos.show_hidden', app: PHOTOS, status: 'held', opens: true,
    title: 'Show the Hidden album in the sidebar',
    description: 'Show the Hidden album in the sidebar ("show hidden photos").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Show Hidden Photo Album'] }],
    tier: 'reversible', cues: ['hidden', 'hidden album', 'unhide the hidden album', 'hidden photos dikhao', 'hidden pictures'],
    reply: 'The Hidden album is showing. Photos asks for Touch ID to open it.',
  },  // ── R3c: the catalog rulings' accepts ─────────────────────────────────────────────────────────
  // An empty private album with its name field focused; with photos selected it is "New Album with Selection". Nothing is typed after it.
  // Named by "new album" or "create", never the bare album: "show the album" is no new one.
  {
    id: 'photos.new_album_ui', app: PHOTOS, status: 'held', opens: true,
    title: 'New album',
    description: 'Start a new, empty album in Photos, its name left for them to type ("make a new album").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+n' }],
    tier: 'reversible', cues: ['create', 'naya', 'new album', 'create an album', 'create album', 'naya album banao', 'new album with these photos'],
    reply: 'Started a new album in Photos. Type its name.',
  },
  // The show half of the sidebar, pressed by its live title, and the zoom out half of photos.zoom_in.
  {
    id: 'photos.show_sidebar', app: PHOTOS, status: 'held', opens: true,
    title: 'Show the Photos sidebar',
    description: 'Show the Photos sidebar ("show the sidebar in photos").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Show Sidebar'], pair: ['Show Sidebar', 'Hide Sidebar'] }],
    tier: 'reversible', cues: ['sidebar', 'sidebar dikhao', 'back the sidebar'],
    reply: 'Showed the sidebar in Photos.',
  },
  {
    id: 'photos.zoom_out', app: PHOTOS, status: 'held',
    title: 'Zoom out on Photos',
    description: 'Smaller thumbnails in Photos ("smaller thumbnails").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Zoom Out'] }],
    tier: 'reversible', cues: ['smaller', 'chhota', 'smaller thumbnails', 'thumbnails smaller', 'smaller pictures'],
    reply: 'Zoomed out.',
  },
];
